import { render, staticRenderFns } from "./NumberCounterJs.vue?vue&type=template&id=091715a6&"
import script from "./NumberCounterJs.vue?vue&type=script&lang=js&"
export * from "./NumberCounterJs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports